<template>
  <div id="side-nav" class="pos-fixed pos-top-center w-100" @click="$store.commit('SET_SHOW_SIDE_NAV',false)">
    <div id="menu" class="bg-white shadow-1 h-100 d-flex flex-column" @click.stop="">
      <div class="px-3 pb-3 shadow-1 bg-k10blue fg-white z-1"
           style="padding-top: calc(var(--safe-area-inset-top) + 12px);">
        <div class="h6 m-0 open-sans-bold">Koinonía10</div>
        <div class="mt-2">
          <div class="text-small text-medium">
            <span class="fg-white bg-green border-radius-4 px-1">Perfil K10 activo</span>
          </div>
          <div class="d-flex text-secondary flex-align-center" style="gap: 8px;">
            <div class="k10-vista-pic-thumb">
              <img v-if="vistaActiva.picture_url" :src="vistaActiva.picture_url" alt="" class="k10-vista-pic-img">
              <div class="k10-vista-pic-siglas" :class="`k10-gradient-${vistaActiva.default_gradient}`" v-else>
                <div>{{ nameSiglas(vistaActiva.nombre) }}</div>
              </div>
            </div>
            <div style="flex: 1 1 auto; overflow-x: hidden">
              <div class="text-medium elipsis-container">{{ vistaActiva.nombre }}</div>
              <div class="elipsis-container">@{{ vistaActiva.username }}</div>
            </div>
            <button class="button small bg-transparent fg-white bd-white rounded text-medium py-1"
                    @click="toVistaDifusion()">
              Ver perfil
            </button>
          </div>
        </div>
      </div>
      <transition-group name="slide-from-top" tag="div">
        <div class="p-3 fg-k10red c-pointer text-medium text-secondary z-1 bg-white" key="change-activa"
             @click="setShowAllVistas()">
          <i class="fa-regular fa-circle-user mr-3 fa-xl"></i><span>Cambiar perfil activo</span>
        </div>
        <select-activa v-if="showAllVistas" class="border-bottom border-top bd-black fg-black py-1 w-100"
                       @error="setShowAllVistas()" key="select-activa">
        </select-activa>
      </transition-group>
      <div class="z-1 d-flex flex-column flex-justify-end" style="flex: 1 0 auto">
        <div class="p-3 fg-k10blue c-pointer text-medium text-secondary bg-white border-top bd-gray"
             @click="showTerminos()">
          <i class="fa-brands fa-readme mr-3 fa-xl"></i><span>Términos y Condiciones</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {siglas} from "@/mixins/koinonia10/siglas"
import selectActiva from "@/components/koinonia10/select-activa.vue"
import terminosCondiciones from "@/components/fondos/terminos-condiciones.vue"

export default {
  name: "side-nav",
  data() {
    return {
      showAllVistas: false,
    }
  },
  components: {selectActiva},
  mixins: [siglas],
  computed: {
    vistaActiva() {
      return this.$store.getters.vistaDifusionActiva
    }
  },
  methods: {
    setShowAllVistas() {
      this.showAllVistas = !this.showAllVistas
    },
    toVistaDifusion() {
      this.$router.push({name: 'koinonia10-vista-difusion', params: {username: this.vistaActiva.username}})
      this.$store.commit('SET_SHOW_SIDE_NAV',false)
    },
    showTerminos() {
      this.$store.commit('PUSH_TO_FULL_MODAL_POSITIONS', window.scrollY)
      this.$FModal.show(
        {
          component: terminosCondiciones,
          overlayStyles: {
            backgroundColor: 'rgba(12, 52, 161, 0.27)'
          },
          clickToClose: true,
        },
        {
          documentoSlug: 'terminos-y-condiciones-koinonia10'
        }
      )
    },
  }
}
</script>

<style scoped>
#side-nav {
  height: calc(var(--vh) * 100);
}
#menu {
  max-width: 320px;
  width: calc(100% - 56px);
  overflow-y: scroll;
}
.button {
  white-space: unset;
  height: unset;
  line-height: unset;
}
</style>